import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import * as MesAct from '../../Actions/MesActions';
import { connect } from 'react-redux';
import { mapStateToPropsWrapper } from '../CaptureErreurs';
import { Link } from 'react-router-dom';

class LigneVote extends Component {
    constructor(props) {
        super(props);
    }

    componentWillMount() {
    }


    render() {
        const {
            NumVoteForm, Numero1, Numero2, ODJ_Txt, Vote, Decision_Txt, TypeVote, Libelle, TotTan, NumReunion,
        } = this.props.Vot;
        return (
            <tr
                // className={`clickable-row`}
                title={ODJ_Txt}
            >
                {this.props.voter==1 ? (
                <td className={`acc-table-vote`}>
                    <Link to={ {pathname: `/MesInformations/MonAG/MesVotes/${NumReunion}`, state: { index: this.props.index }}} style={{color:"#000"}} >
                        <div className={Numero2>0 ? `td-decale` : ``} >
                                    <span className="fa fa-stack" style={{fontSize:"0.7rem",marginRight:"5px",color:"#fd7e14"}}>
                                        <i className="fa fa-regular fa-pencil fa-stack-1x"></i>
                                        <i className="fa fa-regular fa-circle-thin fa-stack-2x"></i>
                                    </span>
                            {Numero2==0 ? `${Numero1} - ` : `${Numero1} - ${Numero2} - `}
                            {Libelle}
                        </div> 
                    </Link>
                </td>
                ) : (
                <td className={`acc-table-vote`}>
                    <div className={Numero2>0 ? `td-decale` : ``}>
                        {Numero2==0 ? `${Numero1} - ` : `${Numero1} - ${Numero2} - `}
                        {Libelle}
                    </div> 
                </td>
                )}
                {TypeVote ==7 && TotTan>0 ? <td className='text-center acc-td-vote' colSpan={'3'} style={{backgroundColor:'#EEE'}}> Sans vote </td> : null}
                {TypeVote <7 && TotTan<=0 ? <td className='text-center acc-td-vote' colSpan={'3'} style={{backgroundColor:'#EEE'}}> Non votant </td> : null}
                {TypeVote <7 && TotTan>0 ? <td className='text-center acc-td-vote'>
                    {Vote==1 && TypeVote <7 && TotTan>0 ? <i className={'text-success fas fa-check'} style={{paddingLeft:'10px',paddingRight:'5px'}} /> : null}
                </td> : null}
                {TypeVote <7 && TotTan>0 ? <td className='text-center acc-td-vote' style={TypeVote ==7 || TotTan<=0 ? {backgroundColor:'#EEE'} : {backgroundColor:'#FFF'}}>
                {Vote==2 && TypeVote <7 && TotTan>0  ? <i className={'text-danger fas fa-check'} style={{paddingLeft:'10px',paddingRight:'5px'}} /> : null}
                </td> : null}
                {TypeVote <7 && TotTan>0 ? <td className='text-center acc-td-vote' style={TypeVote ==7 || TotTan<=0 ? {backgroundColor:'#EEE'} : {backgroundColor:'#FFF'}}>
                {Vote==3 && TypeVote <7 && TotTan>0  ? <i className={' fas fa-check'} style={{paddingLeft:'10px',paddingRight:'5px'}} /> : null}
                </td> : null}
            </tr>
        );
    };
}
LigneVote.displayName = 'LigneVote';

function mapStateToProps() {
    return {};
}

function mapDispatchToProps(dispatch) {
    return { actions: bindActionCreators(MesAct, dispatch) };
}

export default connect(mapStateToPropsWrapper(mapStateToProps), mapDispatchToProps)(LigneVote);



// WEBPACK FOOTER //
// ./src/components/MonAG/LigneVote.js